import React from "react";
import messageImg from "assets/images/message.svg";
import whatsappImg from "assets/images/whatsapp.svg";
import "./LoginContactUs.scoped.scss";
import * as TagManager from "core/common/seo/tagManager";
import useStore from "core/custom-hooks/useStore";
import mobileAppEventType from "core/common/types/mobileAppEventType";

const LoginContactUs = () => {
  const { state } = useStore();
  const { mobileAppWrapperData,isMobileApp} = state;
  const {mobileEventEmitter } = mobileAppWrapperData;
  const isAndroid = !window.navigator.userAgent?.includes("appleapp");





  return (
    <React.Fragment>
      <div className="cotact-us-actions">
        <a
          onClick={()=> {WhatappButtonClicked(); 
            if(isMobileApp) {
              mobileEventEmitter(mobileAppEventType.sendWhatsapp,{phoneNumber:`972541466492`})} 
          }}
          target="_blank"
          href={isMobileApp?"javascript:void(0)" : "https://wa.me/972541466492"}
        >
          <div className="icon icon-whatsapp">
            <img src={whatsappImg} alt="whatsappImg" />
          </div>
          <div className="icon-text">
            לשיחה עם נציג <span>ב-whatsapp</span>
          </div>
        </a>

        <a
          href="mailto:1800@d.co.il"
          title="mailto:1800@d.co.il"
          onClick={()=> {EmailTextClicked();
            if(isAndroid && isMobileApp) {
              mobileEventEmitter(
                 mobileAppEventType.mailTo,
             {mail:"mailto:1800@d.co.il"})
            } 
          } }
        >
          <div className="icon icon-message">
            <img src={messageImg} alt="messageImg" />
          </div>
          <div className="icon-text">
          פנייה במייל ל- <span className="mail-direction">1800@d.co.il</span>
          </div>
        </a>
      </div>
      <div className="cotact-us-actions-background" />
    </React.Fragment>
  );
};

const WhatappButtonClicked = () => {
  TagManager.sendGoogleEvent({
    category: `password login page`,
    action: "click on WhatsApp link",
    label: "click",
  });
};

const EmailTextClicked = () => {
  TagManager.sendGoogleEvent({
    category: `password login page`,
    action: "click on contact via email",
    label: "click",
  });
};

export default LoginContactUs;
